import { render, staticRenderFns } from "./H5HorizontalNewsImageList.vue?vue&type=template&id=98b971e4&scoped=true"
import script from "./H5HorizontalNewsImageList.vue?vue&type=script&lang=js"
export * from "./H5HorizontalNewsImageList.vue?vue&type=script&lang=js"
import style0 from "./H5HorizontalNewsImageList.vue?vue&type=style&index=0&id=98b971e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b971e4",
  null
  
)

export default component.exports